// Simple countries list for the multiselect
export const countriesList = [
  { name: 'United States', code: 'US', id: 1 },
  { name: 'United Kingdom', code: 'GB', id: 2 },
  { name: 'Canada', code: 'CA', id: 3 },
  { name: 'Australia', code: 'AU', id: 4 },
  { name: 'Germany', code: 'DE', id: 5 },
  { name: 'France', code: 'FR', id: 6 },
  { name: 'Spain', code: 'ES', id: 7 },
  { name: 'Italy', code: 'IT', id: 8 },
  { name: 'Netherlands', code: 'NL', id: 9 },
  { name: 'Sweden', code: 'SE', id: 10 },
  { name: 'Norway', code: 'NO', id: 11 },
  { name: 'Denmark', code: 'DK', id: 12 },
  { name: 'Finland', code: 'FI', id: 13 },
  { name: 'Poland', code: 'PL', id: 14 },
  { name: 'Austria', code: 'AT', id: 15 },
  { name: 'Belgium', code: 'BE', id: 16 },
  { name: 'Switzerland', code: 'CH', id: 17 },
  { name: 'Ireland', code: 'IE', id: 18 },
  { name: 'Portugal', code: 'PT', id: 19 },
  { name: 'Greece', code: 'GR', id: 20 },
  { name: 'Czech Republic', code: 'CZ', id: 21 },
  { name: 'Romania', code: 'RO', id: 22 },
  { name: 'Hungary', code: 'HU', id: 23 },
  { name: 'Bulgaria', code: 'BG', id: 24 },
  { name: 'Croatia', code: 'HR', id: 25 },
  { name: 'Slovakia', code: 'SK', id: 26 },
  { name: 'Slovenia', code: 'SI', id: 27 },
  { name: 'Estonia', code: 'EE', id: 28 },
  { name: 'Latvia', code: 'LV', id: 29 },
  { name: 'Lithuania', code: 'LT', id: 30 },
  { name: 'Japan', code: 'JP', id: 31 },
  { name: 'South Korea', code: 'KR', id: 32 },
  { name: 'China', code: 'CN', id: 33 },
  { name: 'India', code: 'IN', id: 34 },
  { name: 'Brazil', code: 'BR', id: 35 },
  { name: 'Mexico', code: 'MX', id: 36 },
  { name: 'Argentina', code: 'AR', id: 37 },
  { name: 'Chile', code: 'CL', id: 38 },
  { name: 'Colombia', code: 'CO', id: 39 },
  { name: 'Peru', code: 'PE', id: 40 },
  { name: 'South Africa', code: 'ZA', id: 41 },
  { name: 'New Zealand', code: 'NZ', id: 42 },
  { name: 'Singapore', code: 'SG', id: 43 },
  { name: 'Malaysia', code: 'MY', id: 44 },
  { name: 'Thailand', code: 'TH', id: 45 },
  { name: 'Indonesia', code: 'ID', id: 46 },
  { name: 'Philippines', code: 'PH', id: 47 },
  { name: 'Vietnam', code: 'VN', id: 48 },
  { name: 'Turkey', code: 'TR', id: 49 },
  { name: 'Russia', code: 'RU', id: 50 },
];
